<template>
  <div
    class="aha-input__wrapper"
    ref="inputSearchContainer"
  >
    <input
      :type="type"
      :placeholder="placeholder"
      :class="[
        `aha-input-${size}`,
        'aha-input',
        {
          'rounded': rounded,
          'aha-input-limit': maxLength,
          'hover:border-primary-90 focus:border-primary-90': highlightOnHover,
          error,
        },
        classes
      ]"
      :required="required"
      :autofocus="autofocus"
      :value="value"
      @input="handleInput"
      @keyup="handleKeyup"
      v-on="listeners"
      :maxlength="maxLength"
      ref="inputSearch"
      :disabled="disabled"
    >
    <aha-icon
      v-show="value"
      name="close-o"
      width="14"
      height="14"
      viewBox="0 0 10 10"
      class="text-base-50 -ml-6 cursor-pointer"
      @click="clearInput()"
    />

    <div class="aha-input-search-button">
      <slot name="enterButton">
        <aha-button
          @click="handleSearch()"
          @keydown.enter="handleSearch()"
          :disabled="disabled"
          v-if="enterButton"
        >
          {{ enterButton }}
        </aha-button>
        <aha-icon-button
          v-else
          classes="aha-input-search-button__icon"
          @click="handleSearch()"
          variant="secondary"
          @keydown.enter="handleSearch()"
          :disabled="disabled"
        >
          <aha-icon
            name="search"
            width="18"
            height="18"
            viewBox="0 0 24 24"
          />
        </aha-icon-button>
      </slot>
    </div>
  </div>
</template>

<script>
import AhaIcon from '../Icon.vue'
import AhaButton from '../Button.vue'
import AhaIconButton from '../IconButton.vue'

export default {
  components: {
    AhaIcon,
    AhaButton,
    AhaIconButton,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      default: '',
      type: [String, Number],
    },
    type: {
      default: 'text',
      type: String,
    },
    placeholder: {
      default: '',
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    autofocus: {
      default: false,
      type: Boolean,
    },
    size: {
      default: 'md',
      type: String,
    },
    maxLength: {
      default: null,
      type: Number,
    },
    classes: {
      type: String,
      default: '',
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    error: {
      type: Boolean,
      default: false,
    },
    focus: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    highlightOnHover: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: String,
      default: '100px',
    },
    enterButton: {
      type: String,
      default: '',
    },
  },
  computed: {
    listeners() {
      const { input, keyup, ...listeners } = this.$listeners
      return listeners
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.focus) {
        this.$refs.inputSearch.focus()
      }
    })
  },
  methods: {
    handleInput($event) {
      this.$emit('input', $event.target.value)
    },
    handleKeyup($event) {
      this.$emit('keyup', $event)
    },
    handleSearch($event) {
      this.$emit('search', $event)
    },
    clearInput() {
      this.$emit('input', '')
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-input__wrapper {
  @apply relative w-full table;
}

.aha-input-search-button {
  @apply table-cell w-px align-middle whitespace-nowrap;
  inset-inline-start: -1px;

  &.error, &:hover.error {
    border: 1px solid #ff5050;
    border-color: #ff5050;
  }
}

.aha-input-search-button__icon {
  @apply inline-block items-center px-2.5 py-0 h-10 rounded rounded-l-none border border-secondary-20;

  &:focus:not(.active):not(:disabled) {
    @apply border-primary-90 border text-brand-a100;
    box-shadow: unset;
  }
}

.aha-input {
  @apply appearance-none;
  @apply px-2 h-10 text-sm w-full border border-secondary-20 rounded-r-none;
  @apply focus:bg-primary-20 focus:outline-none;
  @apply hover:bg-primary-20;
  @apply placeholder-base-70;
  font-size: inherit;
  font-weight: inherit;
  &.error, &:hover.error {
    border: 1px solid #ff5050;
    border-color: #ff5050;
  }
}

.aha-input-limit {
  @apply pr-9;
}

.aha-input-group>.aha-input__wrapper>.aha-input {
  @apply rounded-l-none;
}

.aha-input-group:hover>.aha-input__wrapper>.aha-input {
  @apply border-primary-90 bg-primary-20;
}

.aha-input.aha-input-sm {
  @apply h-8 text-xs;
  + .aha-input--char-counter {
    @apply h-8;
  }
}
.aha-input.aha-input-md {
}
.aha-input.aha-input-lg {
}
</style>
